module.exports = __webpack_public_path__ + "2f87eeb8f0e046b765b53720a7a77de5.fbx";